const Stake = () => import(/* webpackChunkName: "stake" */ "@/views/Stake.vue");
const NotFound = () =>
  import(/* webpackChunkName: "not-found" */ "@/views/NotFound.vue");

export const mainRoutes = [
  {
    path: "/",
    component: Stake,
  },
  // catch all 404 - define at the very end
  {
    path: "*",
    component: NotFound,
  },
];
